import { render, staticRenderFns } from "./IssueListItemRelationListItem.vue?vue&type=template&id=65331d5e&scoped=true"
import script from "./IssueListItemRelationListItem.vue?vue&type=script&lang=js"
export * from "./IssueListItemRelationListItem.vue?vue&type=script&lang=js"
import style0 from "./IssueListItemRelationListItem.vue?vue&type=style&index=0&id=65331d5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65331d5e",
  null
  
)

export default component.exports